import { Component } from '@angular/core';

@Component({
  selector: 'app-items-skeleton',
  standalone: true,
  templateUrl: './items-skeleton.component.html',
  styleUrl: './items-skeleton.component.scss'
})
export class ItemsSkeletonComponent {
  readonly numberOfCols = new Array(6);
  readonly numberOfRows = new Array(5);
}
